<template>
  <div>
    <Logo></Logo>
    <!-- 返回栏，关于荣誉 -->
    <!-- <FirstHeader></FirstHeader> -->
    <div><img class="bg" :src="image"></div>
    <!-- 分割的距离 -->

    <!-- 放置列表循环荣誉 -->

        <div>
        <div>
            <div class="box4">
            <ul v-for="(list) in lists" class="ul">
                <li class="li">
                    <img  class="dian" src="../../assets/about/dian.png"/>
                    <!-- <div class="time">{{list}}</div> -->
                    <div class="text">{{list.title}}</div>
                    </li>
            </ul>
        </div>
        </div>

    </div>
    <div style="height:6.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import FirstHeader from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Tabbar from '../Index/Index_components/Tabbar.vue'
import Logo from "../Index/Index_components/logo.vue"
export default {
  name: 'Honor',
  components: {
    // FirstHeader,
    Tabbar,
    Logo,
  },
  created () {
    this.local()
  },
  methods: {
    local () {
      var storage = window.localStorage
      if (!storage) {
        return false
      } else {
        if (storage.getItem('honor')) {
          var honor = JSON.parse(storage.getItem('honor'))
          if (honor.data.code === 200) {
            this.lists = honor.data.data
          }
          if (honor.image.code === 200){
            this.image = honor.image.data.image
          }
          if (new Date().getTime() - honor.time > 6500000) {
            storage.removeItem('honor')
          }
        }
        else {
          this.getHonor()
        }
      }
    },
    async getHonor () {
      const { data: data } = await api.getHonor()
      const { data: image } = await api.getAbout()
      var currTime = new Date().getTime()
      window.localStorage.setItem('honor', JSON.stringify({
        time: currTime,
        data: data,
        image: image
      }))
      if (data.code === 200) {
        this.lists = data.data
        console.log(this.lists)
      }
      if (image.code === 200) {
        this.image = image.data.image
      }
    }
  },
  data () {
    return {
      lists: [],
      image: ''
    }
  },
}
</script>
<style scoped>
/* 顶部背景图片 */
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.ul {
  display: flex;
  list-style-type: none;
}
.li {
  font-size: 1.75rem;
  padding-top: 3rem;
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
}
.dian {
  margin-right: 1rem;
  margin-left: 1.5rem;
  width: 0.875rem;
  height: 0.875rem;
  padding-top: 0.78125rem;
}
.time {
  padding-right: 2rem;
  min-width: 14.025rem;
  color: #666666;
}
.text {
  font-size: 1.75rem;
  color: #333333;
}
</style>
